import { DateTime } from "luxon";
import type { ImportItem } from "../../../api/types";
import { matchesAssignedState } from "../../../components/AssignedStateToggle";
import type { Filters } from "./types";
import { hasImportWarnings } from "./warnings";

export const filterImports = (
  imports: ImportItem[],
  filters: Filters,
): ImportItem[] => {
  const pattern = filters.namePattern.trim().toLowerCase();
  const from = filters.from
    ? DateTime.fromISO(filters.from).startOf("day")
    : null;
  const to = filters.to ? DateTime.fromISO(filters.to).endOf("day") : null;

  return imports.filter((item) => {
    const isDeleted = !!item.deletedAt;
    if (filters.view === "active" && isDeleted) return false;
    if (filters.view === "deleted" && !isDeleted) return false;
    if (!matchesAssignedState(hasImportWarnings(item), filters.warnings))
      return false;
    if (
      filters.importers.length > 0 &&
      !filters.importers.includes(item.importerName)
    )
      return false;
    if (pattern) {
      const haystack = `${item.importerName} ${item.id}`.toLowerCase();
      if (!haystack.includes(pattern)) return false;
    }
    if (from || to) {
      const imported = DateTime.fromISO(item.dateImported);
      if (!imported.isValid) return false;
      if (from && imported < from) return false;
      if (to && imported > to) return false;
    }
    return true;
  });
};
